"use strict";
/**
 * Regras de posição e disponibilidade para o gol.
 *
 * A pelada tem dois dados distintos que o enum antigo misturava: *onde a pessoa
 * joga* (zagueiro, lateral, meio-campo, atacante, goleiro) e *se ela aceita ir
 * ao gol quando falta goleiro*. Separá-los deixou possível representar o
 * zagueiro que quebra o galho no gol — mas criou uma combinação sem sentido,
 * `position = GOALKEEPER` com `canPlayGoalkeeper = false`.
 *
 * O banco recusa essa combinação com um CHECK, e os schemas Zod recusam quando
 * os dois campos chegam juntos. Falta o caso do PATCH parcial, em que só um dos
 * dois vem e o outro está no banco: é o que estas funções resolvem, sempre
 * sobre o par *efetivo* (o que vai ficar gravado), nunca sobre o payload.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveGoalkeeperFlag = resolveGoalkeeperFlag;
exports.initialGoalkeeperFlag = initialGoalkeeperFlag;
exports.goalkeeperAffinity = goalkeeperAffinity;
const types_1 = require("@nossorachao/types");
/**
 * Resolve o par posição/gol a partir do estado atual e do que veio no PATCH.
 *
 * Regra: quem escolhe "goleiro" está dizendo que vai ao gol, então a flag é
 * derivada em vez de exigida — pedir para o usuário marcar duas coisas que
 * dizem o mesmo é atrito puro.
 *
 * @returns o par efetivo, ou `null` quando a entrada é contraditória
 *          (goleiro que explicitamente recusa ir ao gol).
 */
function resolveGoalkeeperFlag(current, patch) {
    const position = patch.position ?? current.position;
    if (position === types_1.PlayerPosition.GOALKEEPER) {
        // Recusa explícita conflita com a posição escolhida: quem chamou precisa
        // decidir qual dos dois vale, não cabe ao servidor adivinhar.
        if (patch.canPlayGoalkeeper === false)
            return null;
        return { position, canPlayGoalkeeper: true };
    }
    return {
        position,
        canPlayGoalkeeper: patch.canPlayGoalkeeper ?? current.canPlayGoalkeeper,
    };
}
/** Mesma regra, para criação: não há estado anterior de onde herdar. */
function initialGoalkeeperFlag(position, canPlayGoalkeeper) {
    if (position === types_1.PlayerPosition.GOALKEEPER)
        return true;
    return canPlayGoalkeeper ?? false;
}
/**
 * Quem improvisa no gol com menos prejuízo: quanto mais defensivo o setor,
 * menor o número. Usado como desempate ao escalar o gol e ao ordenar listas.
 */
function goalkeeperAffinity(position) {
    if (position === types_1.PlayerPosition.GOALKEEPER)
        return -1;
    switch (types_1.POSITION_SECTOR[position]) {
        case 'DEFENSE':
            return 0;
        case 'MIDFIELD':
            return 1;
        default:
            return 2;
    }
}
//# sourceMappingURL=position.js.map